<!-- Desktop -->
@if (!isMobile) {

  <!-- Gallery - Desktop -->
  <div class="c__gallery">
    @if (zoom) {
      <div #zoomResult class="c__zoom-result is-hidden">
        <div #zoomBackground class="c__zoom-background" [attr.data-twic-background]="'url(' + twicBackground + ')'"></div>
      </div>
    }
    <div class="{{ mainImages?.length > 1 ? 'c__gallery_grid' : 'c__gallery_main'}}">
      @if (isLoading) {
        <div role="presentation">
          <sd-skeleton
            [appearance]="SkeletonAppearanceEnum.media"
            [ratio]="ImageRatioEnum.r1_1"
            [sizeChangeMobile]="false"
            [count]="1"
          />
        </div>
      } @else {
        @for (image of mainImages; track $index) {
          <sd-banner #mediaBanner
            [isComponentLoading]="isLoading"
            [media]="image"
            [isFit]="false"
            [hasModal]="true"
            [twicPicsAutoSize]="$index < 4 ? false : true"
            (click)="toggleModal($index)"
            (mediaPlay)="onVideoPlayed()"
            (mediaEnded)="onVideoEnded()"
            [imgRatio]="ImageRatioEnum.r1_1"
            [mediaTitle]="galleryName"
          />
          @if (!image?.isVideo && $first) {
            <div class="c__product-other-info">
              @if (refurbishedData) {
                <sd-product-logo [media]="refurbishedData" [width]="87" />
              }
              @if (madeInData) {
                <sd-product-logo [media]="madeInData" />
              }
            </div>
          }
        }
      }
    </div>
  </div>

} @else {

  <!-- Mobile Gallery -->
  <div class="c__gallery">
    @if (isLoading) {
      <div role="presentation">
        <sd-skeleton
          [appearance]="SkeletonAppearanceEnum.media"
          [ratio]="ImageRatioEnum.r4_3"
          [sizeChangeMobile]="false"
          [count]="1"
        />
      </div>
    } @else if (configGallery) {
      <swiper #gallerySwiper
        [config]="configGallery"
        (realIndexChange)="updatePagination($event, 'gallery')"
        (imagesReady)="updateSlidesStatus()"
        (slideChangeTransitionEnd)="updateSlidesStatus()"
        role="presentation"
      >
        @for (image of mainImages; track $index) {
          <ng-template swiperSlide>
            <sd-banner #mediaBanner
              [isComponentLoading]="isLoading"
              [twicPicsAutoSize]="(configGallery?.slidesPerView === 'auto') || ($index > +configGallery?.slidesPerView)"
              [mediaTitle]="galleryName"
              [imgRatio]="ImageRatioEnum.r4_3"
              [isFit]="true"
              (mediaPlay)="onVideoPlayed()"
              (mediaEnded)="onVideoEnded()"
              [media]="image"
              (click)="toggleModal()"
            />
            @if (!image?.isVideo && $first) {
              <div class="c__product-other-info">
                @if (refurbishedData) {
                  <sd-product-logo [media]="refurbishedData" [width]="87" />
                }
                @if (madeInData) {
                  <sd-product-logo [media]="madeInData" />
                }
              </div>
            }
          </ng-template>
        }
      </swiper>
    }
  </div>

}

<!-- Desktop / Mobile Modal -->
@if (shouldRenderModal) {
  <sd-modal-default
    [hasHeader]="false"
    [showCloseText]="true"
    [titleHidden]="true"
    [(isOpened)]="isOpen"
    [modalTitleLevel]="4"
    [modalTitle]="'sliders.actions.gallery' | translate"
    [modalCustomClass]="'c__modal-gallery' + (isMobile ? ' is-mobile' : '') + (thumbnails.length <= 1 ? ' no-thumbs' : '')"
  >
    <p id="modalTitle" class="is-visually-hidden" aria-hidden="true">
      {{'sliders.actions.gallery' | translate}}
    </p>
    <div class="c__gallery-modal">
      <div class="c__swiper-wrapper-modal">
        @if (!!configGalleryModal && mainImages?.length > 0) {
          <swiper #gallerySwiperModal
            [config]="configGalleryModal"
            (realIndexChange)="updatePagination($event, 'galleryModal')"
            (imagesReady)="updateSlidesStatus()"
            (slideChangeTransitionEnd)="updateSlidesStatus()"
            [thumbs]="{ swiper: defaultSwiperModalThumbs?.swiperRef }"
            role="presentation"
            #zoomContainer
          >
            @for (image of mainImages; track $index) {
              <ng-template swiperSlide>
                <sd-banner #mediaBanner
                  [isComponentLoading]="isLoading"
                  [media]="image"
                  [isFit]="true"
                  (mediaPlay)="onVideoPlayed()"
                  (mediaEnded)="onVideoEnded()"
                  [imgRatio]="ImageRatioEnum.default"
                  [mediaTitle]="galleryName"
                  [hasBorder]="true"
                  [twicPicsAutoSize]="true"
                  [isZoomed]="isZoomed"
                  [zoomLevel]="zoomLevel"
                  (mousedown)="onImageDown($event)"
                  (touchstart)="onImageDown($event)"
                  (mousemove)="onImageMove($event)"
                  (touchmove)="onImageTouchMove($event)"
                  (mouseup)="onImageUp()"
                  (touchend)="onImageUp()"
               />
              </ng-template>
            }
          </swiper>
        }
        @if (thumbnails.length > 1) {
          <div class="c__controls">
            <button sd-button
              type="button"
              (click)="slidePrev()"
              [isIcon]="true"
              [brand]="brand"
              icon="icon-arrow-left"
              class="c__swiper-button-prev c__swiper-button-prev-gallery-modal"
            >
              <span class="is-visually-hidden">{{ 'sliders.actions.prev' | translate: {'context': context} }}</span>
            </button>
            <button sd-button
              type="button"
              [isIcon]="true"
              [brand]="brand"
              (click)="slideNext()"
              icon="icon-arrow-right"
              class="c__swiper-button-next c__swiper-button-next-gallery-modal"
            >
              <span class="is-visually-hidden">{{ 'sliders.actions.next' | translate: {'context': context} }}</span>
            </button>
          </div>
        }
      </div>
      <div class="zoom__btns">
        <button sd-button
          type="button"
          [isSecondary]="true"
          [isIcon]="true"
          [brand]="brand"
          icon="icon-minus"
          [disabled]="zoomLevel === 0 || mainImages?.[currIndex]?.isVideo"
          (click)="zoomOut()"
        ></button>
        <button sd-button
          type="button"
          [isSecondary]="true"
          [isIcon]="true"
          [brand]="brand"
          icon="icon-plus"
          [disabled]="zoomLevel === 2 || mainImages?.[currIndex]?.isVideo"
          (click)="zoomImage()"
        ></button>
      </div>
    </div>
    @if (thumbnails.length > 1) {
      <div class="c__slider">
        @if (!!configDefaultModalThumbs) {
          <swiper
            [config]="configDefaultModalThumbs"
            class="c__thumbs-swiper-modal"
            #defaultSwiperModalThumbs
            role="presentation"
            [watchSlidesProgress]="true"
          >
            @for (thumb of thumbnails; track $index) {
              @let isVideoThumbnail = mainImages?.[$index]?.isVideo;
              <ng-template swiperSlide>
                <sd-banner #thumbMediaBanner
                  [isComponentLoading]="isLoading"
                  [media]="thumb"
                  [isFit]="true"
                  [imgRatio]="ImageRatioEnum.r4_3"
                  class="is-thumbnail {{isVideoThumbnail ? 'is-video' : undefined}}"
                  [isVideoThumbnail]="isVideoThumbnail"
                />
              </ng-template>
            }
          </swiper>
        }
      </div>
    }
  </sd-modal-default>
}
